// components/ui/custom-slider.tsx
import React from "react";
import { Slider } from "@/components/ui/slider";
import { Badge } from "@/components/ui/badge";

interface CustomSliderProps {
  heading?: string;
  subheading?: string;
  value: number[];
  onChange: (value: number[]) => void;
  min?: number;
  max?: number;
  step?: number;
  unit?: string;
  showValue?: boolean;
}

export const VoiceSlider: React.FC<CustomSliderProps> = ({
  heading,
  subheading,
  value,
  onChange,
  min = 0,
  max = 2,
  step = 0.01,
  unit = "sec",
  showValue = true,
}) => {
  return (
    <div className="p-3 bg-muted rounded-xl space-y-1">
      {(heading || subheading) && (
        <div className="flex gap-1 flex-col sm:flex-row">
          {heading && (
            <span className="text-sm font-medium text-foreground">
              {heading}
            </span>
          )}
          {subheading && (
            <span className="text-xs text-muted-foreground">{subheading}</span>
          )}
        </div>
      )}

      <div className="rounded-lg">
        <div className="flex flex-col sm:flex-row sm:gap-4 sm:items-center">
          <div className="flex-1 py-1">
            <Slider
              value={value}
              onValueChange={onChange}
              min={min}
              max={max}
              step={step}
              className="w-full"
            />
            <div className="flex justify-between mt-2">
              <span className="text-xs font-medium text-muted-foreground">
                {min}
                {unit ? ` (${unit})` : ""}
              </span>
              <span className="text-xs font-medium text-muted-foreground">
                {max}
                {unit ? ` (${unit})` : ""}
              </span>
            </div>
          </div>
          {showValue && (
            <Badge
              variant="outline"
              className="h-10 sm:w-20 w-24 bg-white dark:bg-black rounded-md flex items-center justify-center mt-3 sm:mt-0"
            >
              {value[0].toFixed(2)}
              {unit ? ` (${unit})` : ""}
            </Badge>
          )}
        </div>
      </div>
    </div>
  );
};
